import { faFile, faFileCircleCheck, faFolder, faFolderPlus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './FileItem.css';
import { useEffect } from "react";

const FileItem = ({ file, isSelected, onClick, onDoubleClick, onDragStart, onDragOver, onDrop }) => {

    const getFolderIcon = (type) => {
        if (type == 'folder') return faFolder;
        else if (type == 'file') return faFile;
        else if (type == 'sharedFolder') return faFolderPlus
        else if (type == 'sharedFile') return faFileCircleCheck
    }

    // useEffect(() => {
    //     const preventTextSelection = (e) => {
    //         if (e.detail > 1) { // Detect double-click
    //             e.preventDefault(); // Prevent text selection
    //         }
    //     };

    //     document.addEventListener('selectstart', preventTextSelection);

    //     return () => {
    //         document.removeEventListener('selectstart', preventTextSelection);
    //     };
    // }, []);

    return (
        <div className="file-item-container">
            <div
                className={`file-item ${isSelected ? 'selected' : ''}`}
                onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick(e, file); }}
                onDoubleClick={(e) => { e.preventDefault(); e.stopPropagation(); onDoubleClick(file); }}
                draggable
                onDragStart={(e) => onDragStart(e, file)}
                onDragOver={(e) => onDragOver(e, file)}
                onDrop={(e) => onDrop(e, file)}
                title={file.fullPath}
            >
                <FontAwesomeIcon className="file-icon" icon={getFolderIcon(file.type)} />
                <span className="m-0">{file.name}</span>
            </div>
        </div>
    )
}

export default FileItem;